module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Title_Page"
  }, [_c('h2', {
    staticClass: "chaptitle2"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Contents#ch8",
      "id": "rch8"
    }
  }, [_c('b', [_vm._v("Little Things Mean a Lot")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub1"
  }, [_c('b', [_vm._v("“The devil’s in the details,” says an old proverb. It’s true—the littlest things can cause the biggest problems.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', {
    staticClass: "sblue"
  }, [_c('b', [_vm._v("A LINE OF CODE")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("In 2011 a Microsoft programmer working on the first major update of Windows 7 for the European market accidentally left out a line of code that would have given Europe’s 15 million Windows users a choice of Web browsers—such as Safari or Firefox—with which to run the update. Without that line of code, users could only run Internet Explorer (owned by Microsoft). Result: The goof broke a 2009 commitment Microsoft had made to the European Commission to offer a choice of browsers. The software giant had to pay fines and restitution totaling $731 million.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', {
    staticClass: "sblue"
  }, [_c('b', [_vm._v("A MISTRANSLATED WORD")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("When 18-year-old Willie Ramirez was rushed to a Florida hospital in 1980, he was in a coma. His family spoke only Spanish, and kept repeating the word "), _c('i', [_vm._v("intoxicado")]), _vm._v(". Believing Ramirez to be intoxicated, doctors treated him for a drug overdose. However, "), _c('i', [_vm._v("intoxicado")]), _vm._v(" also means “poisoned,” which is what the family was trying to say—that he was suffering from severe food poisoning. By the time the doctors caught the mistake, Ramirez had nearly died. He survived…but was left a quadriplegic. His family sued for malpractice and was awarded $71 million from the hospital…which now has a professional interpreter on call.")])]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }, [_c('p', {
    staticClass: "imagela"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p30.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("Fiberoptic cabling")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', {
    staticClass: "sblue"
  }, [_c('b', [_vm._v("A FEW FEET OF CABLE")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("In 2011, 75-year-old Hayastan Shakarian from the nation of Georgia was searching through a field, looking for old copper wire scraps to sell, when she dug down with her shovel and cut through a fiberoptic cable. Not knowing what it was, she removed a few feet of it. And just like that, millions of people in neighboring Armenia lost their Internet connections. (Georgia supplies 90 percent of Armenia’s Web access.) The blackout lasted twelve hours—halting Armenia’s e-commerce, news service, airports, and several other systems. Normally, the cable would have been farther below ground, but recent rains and mudslides had left the area exposed. Shakarian—dubbed the “spade-hacker” by the press—was charged with damaging property, but at last report, hadn’t been sent to jail.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', {
    staticClass: "sblue"
  }, [_c('b', [_vm._v("A DECIMAL POINT")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("While designing the "), _c('i', [_vm._v("Isaac Peral")]), _vm._v(", part of the Spanish Navy’s “next generation of submarines,” an engineer mistakenly put a "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("decimal point in the wrong place that resulted in the completed sub being 77 tons heavier than the specifications had called for. In 2013 the Spanish Navy reported that it will cost millions of dollars to “slim it down” so the sub won’t sink when it’s launched.")])])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('div', {
    staticClass: "break"
  }, [_c('p', {
    staticClass: "imagela"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p31.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("A 3D-render of what the "), _c('i', [_vm._v("Ariane 5")]), _vm._v(" looked like before it blew up")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', {
    staticClass: "sblue"
  }, [_c('b', [_vm._v("A SOFTWARE GLITCH")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("The European Space Agency’s "), _c('i', [_vm._v("Ariane 5")]), _vm._v(" rocket took 10 years to develop at a cost of $7 billion and blew up 39 seconds into its maiden flight in 1996. The rocket—designed to put the Europeans ahead in the commercial space race—was carrying a payload of four satellites costing a total of around $500 million. According to the investigation, the guidance system shut down 36.7 seconds after launch due to a software bug that was “unable to convert a piece of data from a 64-bit format to a 16-bit format.” That caused the system to “think” it was going off course—which it wasn’t—so it initiated a self-destruct sequence that destroyed the rocket in midair.")])]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }, [_c('p', {
    staticClass: "imagela"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p32.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("The iconic de Havilland Comet was the strongest passenger plane in the world…except for one “minor” design flaw that caused two major tragedies.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', {
    staticClass: "sblue"
  }, [_c('b', [_vm._v("SQUARE WINDOWS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("In separate incidents in 1953 and 1954, three de Havilland Comet jetliners crashed mid-flight. Investigators were baffled as to what went wrong with two-year-old state-of-the-art aircraft. The culprit turned out to be…square windows. Because the steel surrounding each window had four right angles, the hull steadily became weaker in those areas. And unlike earlier, slower planes without pressurized cabins, the Comets were flying faster, higher, and for more flight hours than any passenger plane had before. Before long, the stress became too much to hold the plane together. The Comet fleet was grounded for five years, and the problem was fixed. That’s why, today, all jetliner windows have rounded “corners.”")])]), _vm._v(" "), _c('p', {
    staticClass: "centers"
  }, [_c('b', [_vm._v("ONE IN TEN PEOPLE IN THE WORLD LIVES ON AN ISLAND.")])])])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-231e4f0b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/015_Chapter8.vue
// module id = 102
// module chunks = 0